import React, { FunctionComponent, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import axios from 'lib/axios'
import Impersonate from './Impersonate'
import DeleteUser from './DeleteUser'
import CreateAccount from './CreateAccount'
import * as SC from 'components/TailwindUIToolkit/StyledComponents'
import ArchiveUser from './ArchiveUser'
import MergeUser from './MergeUser'

const DropDown: FunctionComponent<
  React.PropsWithChildren<{ isArchived: boolean; reexecuteQuery: () => void }>
> = ({ isArchived, reexecuteQuery }) => {
  const { userId } = useParams<{ userId: string }>()
  const [isDropDownOpen, setIsDropDownOpen] = useState(false)
  const [hasFirebaseAccount, setHasFirebaseAccount] = useState(false)

  const checkFirebaseAccount = async () => {
    const result = await axios.get(`/admin/users/${userId}/check_firebase_account`)
    const hasAccount = result.data.has_firebase_account
    setHasFirebaseAccount(hasAccount)
  }

  useEffect(() => {
    checkFirebaseAccount()
  }, [userId])

  return (
    <>
      <SC.DropDownContainer>
        <SC.DropDownIcon
          onClick={() => {
            setIsDropDownOpen(!isDropDownOpen)
          }}
        />
        <SC.DropDownMenu isOpen={isDropDownOpen}>
          {hasFirebaseAccount ? (
            <Impersonate />
          ) : (
            <CreateAccount refreshFirebaseAccount={checkFirebaseAccount} />
          )}
          <MergeUser />
          {!isArchived && <ArchiveUser reexecuteQuery={reexecuteQuery} />}
          <DeleteUser />
        </SC.DropDownMenu>
      </SC.DropDownContainer>
    </>
  )
}

export default DropDown
